<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="crt1"><span class="hlink" href="#/text/cvi" title="Link target outside of Sample">Cover</span></p>
<p class="crt"><span class="hlink" href="#/text/tp" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span class="hlink" href="#/text/alsoby" title="Link target outside of Sample">Also by Aliette de Bodard</span></p>
<p class="crt"><span class="hlink" href="#/text/cop" title="Link target outside of Sample">Copyright</span></p>
<p class="crt1"><a class="hlink" href="#/text/c01"><em>Of Dragons, Feasts and Murders</em></a></p>
<p class="crt1"><a class="hlink" href="#/text/c01">Sneak Peek! <em>Of Charms, Ghosts and Grievances</em></a></p>
<p class="crt"><span class="hlink" href="#/text/ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="crt"><span class="hlink" href="#/text/ata" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?1ed1980d